import React from "react";

export default function MarqueeStrip({ items }) {
  const marqueeItems = items || [
    { text: "Now Showing : Edition 01", highlight: false },
    { text: "The Linen Curation", highlight: false },
    { text: "From Ahmedabad to Your Doorstep", highlight: false },
    { text: "Shop Tailor-Made Quality", highlight: false },
    { text: "Pieces Are Limited", highlight: true },
    { text: "Discover Asvasa", highlight: false },
  ];

  return (
    <div
      className="bg-[#c3ba9e] border-y border-[#1A1A1A]/30 py-3 md:py-4 overflow-hidden"
      data-testid="marquee-strip"
    >
      <div className="marquee-track text-[10px] md:text-[11px] tracking-[0.28em] md:tracking-[0.32em] uppercase text-[#1A1A1A]/85">
        {Array.from({ length: 2 }).map((_, k) => (
          <span key={k} className="flex items-center">
            {marqueeItems.map((item, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span
                  className={`px-5 md:px-8 ${
                    item.highlight
                      ? "text-[#6b705c] font-semibold tracking-[0.34em] border border-[#6b705c]/55 bg-[#6b705c]/12 py-1"
                      : ""
                  }`}
                >
                  {item.text}
                </span>
                <span className="text-[#1A1A1A]/40">//</span>
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
